import { Text } from '@wartek-id/text-v1'

import IconBookRaporGraphicDoc from 'assets/icons/img-book-rapor-graphic-doc.svg'

const TabContentHeader = () => {
  return (
    <div className="flex gap-3">
      <IconBookRaporGraphicDoc className="w-16 h-16 shrink-0" />
      <div>
        <Text variant="heading-md">
          Cek Perencanaan Kinerja yang sudah disetujui Kepala Sekolah
        </Text>
        <Text color="subdued" className="mt-1.5">
          Jika terdapat tanda “Ada penyesuaian” artinya Kepala Sekolah mengubah
          Perencanaan Anda. Mohon perhatikan sebelum lanjut sepakati, ya.
        </Text>
      </div>
    </div>
  )
}

export default TabContentHeader
